import type { Action, State } from "./types";

export const initialState: State = {
  user: undefined,
  reminders: undefined,
  reminder: undefined,
  shortReminders: undefined,
  offers: undefined,
  offer: undefined,
};

export const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case "UPDATE_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "UPDATE_REMINDERS":
      return {
        ...state,
        reminders: action.payload,
      };
    case "UPDATE_SHORT_REMINDERS":
      return {
        ...state,
        shortReminders: action.payload,
      };
    case "UPDATE_REMINDER":
      return {
        ...state,
        reminder: action.payload,
      };
    case "UPDATE_OFFERS":
      return {
        ...state,
        offers: action.payload,
      };
    case "UPDATE_OFFER":
      return {
        ...state,
        offer: action.payload,
      };
    default:
      return state;
  }
};
